export const SHOWROOM_COLLECTION = 'showroom';
export const SHOWROOM_SETTINGS_ID = 'settings';
export const SHOWROOM_ROOMS_COLLECTION = 'showroomRooms';
export const TOP_TAB_ID = 'top';

export const DEFAULT_SHOWROOM_TITLE = 'ショールーム';

export const DEFAULT_SHOWROOM_MESSAGE = `「食器の今がわかります」

どんなにネットが便利になっても、伝えきれないことがあります。
こと食器に関しては、触れてみないとわからないことだらけ。
色合い、さわり心地、重たさ、質感

つまり「趣（おもむき）」

当社では、お客様が実際に手に取って商品に触れて頂き、納得いくまで商品選びが出来るように、「完全予約制」の「貸し切りショールーム」を用意しております。
お問い合わせフォームにて、必須事項をご記入の上、メッセージに「ショールーム予約」とご記入下さい。
折り返し弊社担当者よりご連絡いたします。`;

export const DEFAULT_SHOWROOM_ADDRESS = `〒169-0074
東京都新宿区北新宿四丁目13番10号
(EN)
4-13-10 Kita-Shinjuku
Shinjuku-ku, Tokyo 169-0074, Japan

最寄り駅
JR総武線 大久保駅 (北口)より 徒歩10分
JR総武線 東中野駅(東口：北側) より 徒歩10分

営業時間
平日9:00～17:00(土日祝を除く)`;

export const DEFAULT_SHOWROOM_MAP_EMBED =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6479.5842367473415!2d139.69265380000002!3d35.70673289999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188d336112f391%3A0x65cfded1116f5338!2z44CSMTY5LTAwNzQg5p2x5Lqs6YO95paw5a6_5Yy65YyX5paw5a6_77yU5LiB55uu77yR77yT4oiS77yR77yQ!5e0!3m2!1sja!2sjp!4v1727687522868!5m2!1sja!2sjp';

export const parseGoogleMapEmbed = (input) => {
  if (!input || typeof input !== 'string') return '';
  const trimmed = input.trim();
  if (!trimmed) return '';

  const iframeSrc = trimmed.match(/src\s*=\s*["']([^"']+)["']/i);
  const extracted = iframeSrc && iframeSrc[1] ? iframeSrc[1].trim() : trimmed;
  return extracted
    .replace(/&amp;/gi, '&')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/g, "'")
    .trim();
};

export const getStoragePathFromUrl = (imageUrl) => {
  try {
    const url = new URL(imageUrl);
    const path = decodeURIComponent(url.pathname.split('/o/')[1].split('?')[0]);
    return path;
  } catch (error) {
    console.error('Invalid image URL:', error);
    return null;
  }
};
